import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import { getToken } from '../../actions/localStorage';
import { hasDashboardAccess, isScannerOnly } from '../../utils/roles';
import {
	clearAssignDeliveryReturnPath,
	consumeAssignDeliveryReturnPath,
} from '../../utils/assignDeliveryHelpers';

const noAuth = Component => {
	class ComponentNoAuth extends React.Component {

		componentDidMount(){
			const { getUser, authorized, history, usuario } = this.props;
			if(getToken()) getUser();
			if(authorized && usuario){
				if(hasDashboardAccess(usuario)){
					clearAssignDeliveryReturnPath();
					history.replace("/");
				}else if(isScannerOnly(usuario)){
					const back = consumeAssignDeliveryReturnPath();
					history.replace(back || "/assign-delivery");
				}
			}
		}

		componentDidUpdate(prevProps){
			const { authorized, history } = prevProps;
			if(!authorized && this.props.authorized && this.props.usuario){
				const u = this.props.usuario;
				if(hasDashboardAccess(u)){
					clearAssignDeliveryReturnPath();
					history.replace("/");
				}else if(isScannerOnly(u)){
					const back = consumeAssignDeliveryReturnPath();
					history.replace(back || "/assign-delivery");
				}
			}
		}

		render(){
			return (
				<div>
					<Component {...this.props}/>
				</div>
			);
		}
	}

	const mapStateToProps = state => ({
		authorized: state.auth.authorized,
		usuario: state.auth.usuario
	});

	return connect(mapStateToProps, actions)(ComponentNoAuth);
}

export default noAuth;